import { Component, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { BilletService } from 'src/app/services/billet.service';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { ToastService } from 'src/app/services/toast.service';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { MessageUtil } from 'src/app/utils/message.util';
import Swal from 'sweetalert2';
import { MarinaCompany } from 'src/app/models/marina-company';
import { StorageUtil } from 'src/app/utils/storage.util';
import { FinancesService } from 'src/app/services/finances.service';
import { RoleService } from 'src/app/services/role.service';
import { BilletLogService } from 'src/app/services/billet-log.service';
import { BilletLogDialogComponent } from '../../billets-management/billet/billet-dialog/billet-log-dialog.component';

@Component({
  selector: 'app-billet-list-for-invoice',
  templateUrl: './billet-list-for-invoice.component.html',
  styleUrls: ['./billet-list-for-invoice.component.scss'],
})
export class BilletListForInvoiceComponent implements OnInit {
  @Input() invoiceId: number | null = null;

  @ViewChild('table') table: Table;

  billets: any[] = [];
  selectedBillets: any[] = [];
  loading = false;
  error: string | null = null;
  totalBillets: number = 0;
  totalPaid: number = 0;
  billingPortifolioList: any;
  marinaCompanies: MarinaCompany[];
  marinaCompaniesWithDatabase: MarinaCompany[];
  filteredCompanies: { label: string; value: any }[];
  loggedMarina: any;
  globalFilter: string = '';

  constructor(
    private billetService: BilletService,
    @Optional() private config: DynamicDialogConfig,
    private toastService: ToastService,
    private spinner: NgxSpinnerService,
    private messageService: MessageUtil,
    private financesService: FinancesService,
    private roleService: RoleService,
    private billetLogService: BilletLogService,
    private dialog: DialogService,
  ) {}

  ngOnInit(): void {
    const marina = StorageUtil.getMarina();
    this.marinaCompanies = marina.marinaCompanies;
    const id = this.invoiceId ?? this.config?.data?.invoiceId ?? null;
    this.invoiceId = id;
    this.getCompanies(id);

    this.loggedMarina = marina;
  }

  async getCompanies(id: number): Promise<void> {
    this.marinaCompaniesWithDatabase =
      await this.financesService.findCompaniesWithDatabase();
      await this.getBilingPortifolioList();
        if (id != null) {
        this.loadBillets(id);
      } else {
        this.error = 'ID da fatura não informado.';
      }

  }

  async getBilingPortifolioList(): Promise<void> {
    return new Promise<void>(
      async (res) => {
        this.billingPortifolioList = (await this.financesService.getAllBilingPortifolioAsync(null))
          .map((carteira) => {
            carteira.marinaCompany = null;
            return carteira;
          });
        console.log(this.billingPortifolioList);
        for (let index = 0; index < this.marinaCompaniesWithDatabase.length; index++) {
          this.billingPortifolioList = this.billingPortifolioList.concat(
            (await this.financesService.getAllBilingPortifolioAsync(this.marinaCompanies[index]))
              .map((carteira) => {
                carteira.marinaCompany = this.marinaCompanies[index].id;
                return carteira;
              })
          );
        }
        console.log(this.billingPortifolioList);
        res();
      }
    );
  }

  loadBillets(invoiceId: number): void {
    this.loading = true;
    this.error = null;
    this.billetService.getBilletsByInvoiceId(invoiceId).subscribe({
      next: (list) => {
        this.billets = list ?? [];
        this.totalBillets = this.billets.reduce(
          (sum, b) => sum + (Number(b?.value) || 0),
          0,
        );
        this.totalPaid = this.billets.filter((b) => b.paid).reduce(
          (sum, b) => sum + (Number(b?.value) || 0),
          0,
        );
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.message ?? 'Erro ao carregar boletos.';
        this.billets = [];
        this.loading = false;
      },
    });
  }

  filterGlobal(): void {
    if (this.table) {
      this.table.filterGlobal(this.globalFilter, 'contains');
    }
  }

  selectAll(): void {
    const selectable = this.billets.filter((b) => this.canCancel(b));
    this.selectedBillets =
      this.selectedBillets && this.selectedBillets.length === selectable.length
        ? []
        : [...selectable];
  }

  showBilletLogs(billetId: number): void {
    this.spinner.show();
    this.billetLogService.getBilletStatusLogs(billetId).subscribe({
      next: (logs) => {
        this.spinner.hide();
        this.dialog.open(BilletLogDialogComponent, {
          header: 'Logs do Boleto',
          width: '60%',
          data: { logs },
        });
      },
      error: (error) => {
        this.spinner.hide();
        console.error('Erro ao buscar logs do boleto:', error);
        this.toastService.error('Erro ao carregar logs do boleto');
      },
    });
  }

  getStatusLabel(billet: any): string {
    if (!billet?.active) return 'Cancelado';
    if (billet?.paid) return 'Pago';
    if (billet?.refused) return 'Recusado';
    if (billet?.registered) return 'Registrado';
    return 'Pendente';
  }

  checkIfHavePixCopyPasteOnList(): boolean {
    return this.billets.some((x) => x.pixCopyPast);
  }

  checkIfHavePixCopyPaste(billet: any): boolean {
    return billet.pixCopyPast;
  }

  copyToClipboard(billet: any) {
    const pixCopyPaste = billet.pixCopyPast;
    navigator.clipboard.writeText(pixCopyPaste).then(() => {
      this.toastService.success('Pix copiado com sucesso!');
    });
  }

  isToday(file): boolean {
    return moment(file.issueDate)
      .hours(0)
      .minutes(0)
      .seconds(0)
      .milliseconds(0)
      .isSame(moment().hours(0).minutes(0).seconds(0).milliseconds(0));
  }

  getTooltip(billet): string {
    let texto = '';
    if (!billet.paid && billet.registered) {
      texto = billet.anticipated
        ? 'Boleto Antecipado e Registrado'
        : 'Boleto registrado';
    } else if (!billet.registered) {
      texto = billet.anticipated
        ? 'Boleto Antecipado e Não registrado'
        : 'Boleto não registrado';
    } else if (billet.paid) {
      texto = billet.paymentDate
        ? 'Boleto pago em: ' + this.getDateFormatted(billet.paymentDate)
        : 'Boleto pago';
    }
    return texto;
  }

  getDateFormatted(date): string {
    return moment(date).format('DD/MM/YY');
  }

  canCancel(billet): boolean {
    return (
      billet &&
      billet.active &&
      !billet.paid &&
      !billet.valuePaid &&
      (!billet.anticipated || billet.repurchaseDate)
    );
  }

  async openConfirmation(title, text, icon): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      Swal.fire({
        title,
        text,
        icon,
        backdrop: false,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        reverseButtons: true,
      }).then(async (result) => {
        if (result.value) {
          resolve();
        } else if (result.dismiss) {
          reject();
        }
      });
    });
  }

  cancelBilletBank(billet): void {
    this.openConfirmation(
      'Alterar boleto',
      billet.bankCanceled
        ? 'O boleto será alterado para \"Não cancelado no banco\". Deseja continuar?'
        : 'O boleto será alterado para \"Cancelado no banco\". Deseja continuar?',
      'warning',
    ).then(() => {
      this.spinner.show();
      this.billetService
        .cancelBilletBank(billet.id, !billet.bankCanceled)
        .subscribe(
          () => {
            this.messageService.generateMessage(
              'success',
              'SUMMARY.SUCCESS',
              'Boleto alterado com banco.',
            );
            this.loadBillets(this.invoiceId);
            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
            const exception = err.error.data.exception;
            this.messageService.generateMessage(
              exception.type,
              exception.title,
              exception.message,
            );
          },
        );
    });
  }

  billingPortfolio(billet): any {
    const empty = { conta: { nome: '' }, nome: '' };
    if (!this.billingPortifolioList || !Array.isArray(this.billingPortifolioList)) {
      return empty;
    }
    let company;
    const c = this.billingPortifolioList.find((carteira) => {
      if (carteira.idCarteiraCobranca === billet?.idCarteiraCobranca) {
        company =
          this.marinaCompanies && Array.isArray(this.marinaCompanies)
            ? this.marinaCompanies.find(
                (m) => m.companyFederalName === billet?.marinaCompany,
              )
            : undefined;
        if ((!company || !company.finances) && !carteira.marinaCompany) {
          return carteira;
        } else if (company?.finances && carteira.marinaCompany === company.id) {
          return carteira;
        }
      }
    });
    return c ? c : empty;
  }

  async isCurrentUserAdministrator(): Promise<Boolean> {
    const currentUserID = StorageUtil.getUserId();
    return new Promise<Boolean> (async (resolve) => {
      this.roleService.currentUserIsAdministrator(currentUserID).subscribe({
        next: (administratorRole: Boolean) => resolve(administratorRole),
        error: (e) => console.log(e),
      });
    });
  }

  async cancelBillets(): Promise<void> {
    const credentialsAdm = await this.isCurrentUserAdministrator();
    if (!this.selectedBillets || this.selectedBillets.length === 0) {
      this.messageService.generateMessage('warning', 'SUMMARY.WARNING', 'Selecione pelo menos um boleto para cancelar.');
      return;
    }
    credentialsAdm ?
    this.openConfirmation(
      'Cancelar boletos',
      'Os boletos serão cancelados. Esta operação não pode ser desfeita. Deseja continuar?',
      'warning'
    ).then(
      () => {
        this.spinner.show();
        this.billetService.cancelBillets(this.selectedBillets.map((b) => b.id)).subscribe(
          () => {
            this.messageService.generateMessage(
              'success',
              'SUMMARY.SUCCESS',
              'Boletos cancelados com sucesso. Lembre-se de cancelar os boletos no banco.'
            );

            this.selectedBillets = [];
            this.loadBillets(this.invoiceId);
            this.spinner.hide();
          },
          err => {
            this.spinner.hide();
            let exception = err.error;
            console.log(err);

            if(exception.message == null) {
              exception = err.error.data.exception;
              exception.message == null ? exception = '': exception;
            }
            this.messageService.generateMessage(MessageUtil.ERROR, "Sem permissão", exception.message);

          }
        );
      }
    )
      : this.messageService.generateMessage(MessageUtil.ERROR, "Erro", "Você não possui permissão para executar essa ação");
  }
}
